export default __webpack_public_path__ + "static/BayswaterPhysioLogo500-white-4231b581dd9186b50fa5eca41bbd2485.png";